/* A row of chips that scrolls sideways on the phone and snaps to each chip (brand/docs/04-
 * components.md, Chips): the collection's filter chips (snippets/collection-chips.liquid) and the
 * pack page's flavour map chips (sections/pack-flavour-map.liquid), each marked [data-chips-row].
 *
 * A chip that Tab reaches half off the screen does not come into view by itself: the small
 * scroll that would show it snaps back. This brings it to the row's start, where it snaps, so a
 * keyboard user always sees the whole chip and its focus ring.
 */
(() => {
  if (window.lbChipRow) return;
  window.lbChipRow = true;
  document.addEventListener('focusin', (event) => {
    const chip = event.target;
    const row = chip.closest && chip.closest('[data-chips-row]');
    if (!row || chip === row) return;
    const c = chip.getBoundingClientRect();
    const r = row.getBoundingClientRect();
    if (c.left < r.left || c.right > r.right) chip.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();
